import { map } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";

@Injectable()
export class SupportLinksResolve implements Resolve<Object> {
  protected _actionFactory: DefaultActionFactory;

  constructor(@Inject(DefaultActionFactoryToken) actionFactory: DefaultActionFactory) {
    this._actionFactory = actionFactory;
  }

  public resolve(): Observable<Object> {
    return this._actionFactory.getSupportLinks().pipe(map((response: Object) => {
      return response ? response : {};
    }));
    return null;
  }
}
